// VH-228 phase 0: the only markup a stored document may carry — **bold**, *emphasis* and line breaks.
// Parsed into React nodes, never injected as HTML.
import { parseRichText } from './documentFormat'

export function RichText({ text = '' }) {
  return parseRichText(text).map((token, index) => {
    const lines = token.text.split('\n')
    const content = lines.flatMap((line, i) => (i === 0 ? [line] : [<br key={`br-${i}`} />, line]))
    if (token.bold && token.italic) return <strong key={index} className="font-semibold text-gray-900"><em>{content}</em></strong>
    if (token.bold) return <strong key={index} className="font-semibold text-gray-900">{content}</strong>
    if (token.italic) return <em key={index}>{content}</em>
    return <span key={index}>{content}</span>
  })
}

export default RichText
